import { ThemeBuilder } from './ThemeBuilder';
export var vars = {
    baseFontSize: '1rem',
    baseBorderRadius: '.3em',
    baseVPadding: 2,
    baseHPadding: 2,
    basePaddingUnits: 'em',
    baseInputVPadding: 1.5,
    baseInputHPadding: 1,
    baseInputPaddingUnits: 'em',
    uiElementMinHeight: '1em',
    fabSize: 52,
};
export var ThemeLight = ThemeBuilder({ vars: vars });
export var defaultTheme = ThemeLight;
